export const prodFirebaseConfig = {
	apiKey: "AIzaSyC0LQH-VDTuauQJmJD2jnjE-MHnpdOC610",
	authDomain: "call-agents-prod.firebaseapp.com",
	projectId: "call-agents-prod",
	storageBucket: "call-agents-prod.firebasestorage.app",
	messagingSenderId: "141731514461",
	appId: "1:141731514461:web:5cd14c0fc57cd78ee4a5b4",
};
